import { cn } from '../../lib/cn'

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-card bg-surface-alt', className)} />
}

/** Reproduz a forma final do card para nao haver salto quando o dado chega. */
export function SkeletonCardLojista() {
  return (
    <div className="flex gap-3 rounded-card border border-hairline p-3">
      <Skeleton className="h-20 w-20 shrink-0" />
      <div className="flex-1 space-y-2 py-1">
        <Skeleton className="h-4 w-3/5" />
        <Skeleton className="h-3 w-2/5" />
        <Skeleton className="h-3 w-4/5" />
      </div>
    </div>
  )
}

export function SkeletonLista({ quantidade = 6 }: { quantidade?: number }) {
  return (
    <div className="space-y-3" aria-busy="true" aria-label="Carregando">
      {Array.from({ length: quantidade }, (_, i) => (
        <SkeletonCardLojista key={i} />
      ))}
    </div>
  )
}

export function SkeletonGradeCategorias({ quantidade = 6 }: { quantidade?: number }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3" aria-busy="true">
      {Array.from({ length: quantidade }, (_, i) => (
        <Skeleton key={i} className="aspect-4/3" />
      ))}
    </div>
  )
}
